<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.nickname"
              placeholder="人员昵称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.storeName"
              placeholder="门店名称"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.certificateNo"
              placeholder="专卖证号"
              clearable
              @keyup.enter.native="searchData"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-visible.sync="dialogViewVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 查看
import viewDialog from './components/viewDialog'
// 调研问卷明细异常信息API
import { loadSurveyQuestionnaireDetailExceptionListDataApi, exportSurveyQuestionnaireDetailExceptionListDataApi } from "@/api/v2/surveyQuestionnaireDetailException";

export default {
  name: 'SurveyQuestionnaireDetailExceptionView',
  components: { CustomTable2, TableOperation2, viewDialog },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'survey_questionnaire_detail_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['qq_questionnaire_detail_exception_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['qq_questionnaire_detail_exception_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          nickname: '',
          storeName: '',
          certificateNo: '',
          grantResult: '',
        },
      },
      id: null,
      dialogViewVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80, align: 'center' },
      { prop: 'provinceName', label: '省区', filterColumn: 'tsq.province_name', width: 100 },
      { prop: 'questionnaireCode', label: '问卷编号', filterColumn: 'tsq.code', width: 110 },
      { prop: 'questionnaireName', label: '问卷名称', filterColumn: 'tsq.name', width: 200 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tsq.activity_date', width: 110 },
      { prop: 'nickname', label: '昵称', filterColumn: 'tsqd.nickname', width: 150 },
      { prop: 'market', label: '市场', filterColumn: 'tsqd.market', width: 150 },
      { prop: 'storeName', label: '门店名称', filterColumn: 'tsqd.store_name', width: 200 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'tsqd.certificate_no', width: 120 },
      { prop: 'bxPhone', label: '本香门店码绑定电话', filterColumn: 'tsqd.bx_phone', width: 165 },
      { prop: 'uid', label: '问卷用户ID', filterColumn: "tsqd.uid", width: 200 },
      { prop: 'appUserId', label: '小程序用户编号', filterColumn: "tsqd.app_user_id", width: 150 },
      { prop: 'appStoreName', label: '小程序门店名称', filterColumn: "IFNULL(tau.store_name, '')", width: 150 },
      { prop: 'appCertificateNo', label: '小程序专卖证号', filterColumn: "IFNULL(tau.certificate_no, '')", width: 150 },
      { prop: 'appPhone', label: '小程序手机号', filterColumn: "IFNULL(tau.phone, '')", width: 130 },
      { prop: 'exceptionTypeValue', label: '异常类型', filterColumn: "(case tsqde.exception_type when 2 then '录入专卖证号重复' when 3 then '问卷用户重复录入' when 4 then '专卖证号错误' when 5 then '未注册睿零售' when 6 then '腾讯问卷用户ID不一致' when 7 then '录入专卖证号与关联的睿零售不一致' when 8 then '微信用户未绑定睿零售' when 9 then '其他调研专卖证号与匹配专卖证号存在重复' when 10 then '数据关联睿零售重复' else '' end)", width: 150 },
      { prop: 'processResultValue', label: '处理结果', filterColumn: "(case tsqde.process_result when 1 then '待处理' when 2 then '忽略当前异常' when 3 then '当前数据无效' when 4 then '更新腾讯问卷用户ID' when 5 then '更新关联睿零售' when 6 then '解除问卷用户关联睿零售' when 7 then '问卷明细重新关联睿零售' else '' end)", width: 150 },
      { prop: 'remark', label: '备注', filterColumn: 'tsqde.remark', width: 300 },
      { prop: 'exceptionHandlerName', label: '处理人', filterColumn: 'tsqde.exception_handler_name', width: 120 },
      { prop: 'exceptionHandleTime', label: '处理时间', filterColumn: 'tsqde.exception_handle_time', width: 160 },
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSurveyQuestionnaireDetailExceptionListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    handleView (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的腾讯问卷明细异常信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSurveyQuestionnaireDetailExceptionListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
